import { useCollapseDrawer } from 'hooks/useCollapseDrawer';

import s from './CollapseButton.module.scss';

export const CollapseButton = () => {
  const { opened, setOpened } = useCollapseDrawer();

  return (
    <button className={s.collapseButton} onClick={() => setOpened(!opened)}>
      {opened ? (
        <svg
          width="18"
          height="12"
          viewBox="0 0 18 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 9.61L16.59 11L11.58 6L16.59 1L18 2.39L14.44 6L18 9.61ZM0 0H13V2H0V0ZM0 7V5H10V7H0ZM0 12V10H13V12H0Z"
            fill="black"
            fillOpacity="0.56"
          />
        </svg>
      ) : (
        <svg
          width="18"
          height="12"
          viewBox="0 0 18 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="black" fillOpacity="0.56" />
        </svg>
      )}
    </button>
  );
};
